module.exports = __webpack_public_path__ + "static/media/resident-user.9659d9a3.svg";